// extracted by mini-css-extract-plugin
export default {"commentContainer":"AddHomeworkManualy_commentContainer__Rawzp","commentTitle":"AddHomeworkManualy_commentTitle__eAQrI"};